import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wol-loginlayout',
  templateUrl: './loginlayout.component.html',
  styleUrls: ['./loginlayout.component.scss']
})
export class LoginlayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
